<template>
  <div
    v-if="visible && route.name !== 'whitelabel'"
    class="fixed bottom-0 left-0 right-0 z-40 sm:hidden animate-slide-up"
  >
    <div class="bg-white/95 backdrop-blur-md border-t border-gray-200 px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <a
        :href="`https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedMessage}`"
        target="_blank"
        rel="noopener"
        class="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white font-bold py-3 px-6 rounded-xl shadow-lg shadow-green-500/25 active:scale-[0.98] transition-transform"
      >
        <svg class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
        {{ tx.botao }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useTextos } from '../i18n/idioma'

// Na página do White Label este botão levaria ao atendimento do sistema comum, não da revenda
const route = useRoute()

const visible = ref(false)
const phoneNumber = '5547988489706'
const tx = useTextos({
  pt: { botao: 'Falar com especialista', msgA2: 'Olá! Vim pela página do A2 da AutoVolt e quero entender como implementar na minha empresa.', msg: 'Ola! Gostaria de saber mais sobre os agentes de IA da AutoVolt.' },
  en: { botao: 'Talk to a specialist', msgA2: 'Hi! I came from the A2 by AutoVolt page and want to understand how to implement it in my company.', msg: 'Hi! I would like to know more about AutoVolt AI agents.' },
  es: { botao: 'Hablar con un especialista', msgA2: '¡Hola! Vengo de la página de A2 de AutoVolt y quiero entender cómo implementarlo en mi empresa.', msg: '¡Hola! Me gustaría saber más sobre los agentes de IA de AutoVolt.' },
})

const encodedMessage = computed(() => encodeURIComponent(route.path === '/a2' ? tx.value.msgA2 : tx.value.msg))

const handleScroll = () => {
  visible.value = window.scrollY > 600
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.animate-slide-up {
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
